import { StepProps, useAutoNavigate } from '@betterment/js-runtime';
import { Box, Button, H1, H3, HStack, Text, VStack } from '@betterment/samba-react';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import splashImage from '../../images/advisor-network/splash.svg';
import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';

const MATCHING_DETAILS = [
  {
    title: 'Talk with our advisor matching specialists',
    description: 'We’ll learn about your goals and what kind of guidance you’re looking for.',
  },
  {
    title: 'Review qualified advisors',
    description: 'We’ll email you a few Betterment-vetted advisors whose experience fits your needs.',
  },
  {
    title: 'Connect and decide',
    description:
      'Meet your top choice in a free introductory call. If it’s a good fit, you’ll review an agreement and start working together directly.',
  },
];

export const IntroductionStep: React.FC<StepProps> = ({ goToNextStep, goToPreviousStep, flowState }) => {
  const navigate = useAutoNavigate();

  return (
    <WorkflowLayout
      feature="advisor_network"
      pageTitle="Introduction"
      workflowTitle=""
      onBack={goToPreviousStep}
      onClose={() => navigate(flowState.returnToPath)}
      size="full"
    >
      <Box
        css={{
          display: 'flex',
          gap: '56px',
          smDown: {
            display: 'grid',
            gap: 'space.200',
          },
        }}
      >
        <Box
          css={{
            width: '45%',
            smDown: { width: '100%' },
            borderRadius: 'large',
          }}
        >
          <ThemedImage themedAsset={{ dark: splashImage, light: splashImage }} alt="Betterment financial " />
        </Box>
        <VStack css={{ width: '55%', gap: 'space.400', smDown: { width: '100%' } }}>
          <H1 variant="pageTitle">Let’s match you with the right advisor.</H1>
          <VStack css={{ gap: 'space.200' }}>
            {MATCHING_DETAILS.map(({ title, description }, index) => (
              <HStack key={title} css={{ gap: 'space.150' }}>
                <Box
                  css={{
                    flex: '0 0 auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bg: 'background',
                    width: 'size.500',
                    height: 'size.500',
                    p: 'space.100',
                    borderRadius: 'round',
                  }}
                >
                  {index + 1}
                </Box>
                <VStack>
                  <H3 variant="title100">{title}</H3>
                  <Text variant="text100">{description}</Text>
                </VStack>
              </HStack>
            ))}
          </VStack>
          <Box
            css={{
              mt: 'space.100',
              smDown: {
                display: 'flex',
                position: 'fixed',
                bottom: 'space.0',
                left: 'space.0',
                right: 'space.0',
                justifyContent: 'center',
                backgroundColor: 'background.surface',
                paddingY: 'space.100',
                paddingX: 'space.300',
              },
            }}
          >
            <Button onClick={() => goToNextStep()} variant="solidPrimary" css={{ smDown: { width: '100%' } }}>
              Continue
            </Button>
          </Box>
        </VStack>
      </Box>
    </WorkflowLayout>
  );
};
